import React, { Fragment } from 'react';
import { Link, useParams } from 'react-router-dom'
import Services from '../../api/Services';

import ServiceSidebar from './sidebar'
import HeaderTop from '../../components/HeaderTop/HeaderTop'
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar'
import simg1 from '../../images/product/white injera.jpg'
import simg2 from '../../images/product/red injera.jpg'
import simg3 from '../../images/product/kitfo.jpg'
import simg4 from '../../images/product/alicha watt.jpg'
import simg5 from '../../images/product/kinche.jpg'
import simg6 from '../../images/product/korerima.jpg'
import simg7 from '../../images/product/mesob.jpg'
import simg8 from '../../images/product/fork-619148_640.jpg'
import Logo from '../../images/logo.svg'
import catering from '../../images/service/download1.png'
import spices from '../../images/service/berberie.png'
import households from '../../images/service/species.png'

const ServiceSinglePage = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const { slug } = useParams()
    const serviceDetails = Services.find(item => item.slug === slug)

    return (
        <Fragment>
            <HeaderTop />
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <PageTitle pageTitle={serviceDetails.title} pagesub={'Service Single'} />
            <div className="wpo-service-single-area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-12">
                            <div className="wpo-service-single-wrap">
                                <div className="wpo-service-single-item">
                                    <div className="wpo-service-single-main-img">
                                        {slug === 'injera' && (
                                        <img src={simg1} alt="" />
                                        )}
                                        {slug === 'catering services' && (
                                        <img src={catering} alt="" />
                                        )}
                                        {slug === 'spices and ingredients' && (
                                        <img src={spices} alt="" />
                                        )}
                                         {slug === 'household needs' && (
                                        <img src={households} alt="" />
                                        )}
                                    </div>
                                    <div className="wpo-service-single-title">
                                        <h3>{serviceDetails.title}</h3>
                                    </div>
                                    
                                    {/* Service-specific descriptions */}
                                    {slug === 'injera' && (
                                        <p>Our authentic Ethiopian injera is made using traditional methods with premium teff flour. 
                                        The batter undergoes natural fermentation for 2-3 days to develop its characteristic 
                                        slightly sour taste and spongy texture. We offer both 100% teff and mixed flour options 
                                        to suit different dietary needs and preferences.</p>
                                    )}
                                    {slug === 'spices and ingredients' && (
                                        <p>We import premium Ethiopian spices and ingredients directly from source to ensure 
                                        authenticity. Our selection includes berbere (the essential spice blend), mitmita, 
                                        korarima (Ethiopian cardamom), and other hard-to-find ingredients crucial for 
                                        traditional Ethiopian cooking.</p>
                                    )}
                                    {slug === 'catering services' && (
                                        <p>Our catering service brings the complete Ethiopian dining experience to your event. 
                                        We offer traditional dishes like doro wat, kitfo, and vegetarian platters, served on 
                                        injera with all the customary sides. Our service includes food preparation, setup, 
                                        and optional traditional coffee ceremony.</p>
                                    )}
                                    {slug === 'household needs' && (
                                        <p>We provide essential Ethiopian household items including traditional coffee pots 
                                        (jebena), serving baskets (mesob), and other cultural items. These authentic products 
                                        help maintain Ethiopian traditions in your home and make perfect gifts for special 
                                        occasions.</p>
                                    )}
                                    
                                     {slug === 'injera' && (
                                    <div className="row mt-4">
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src={simg1} alt=""/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src={simg2} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                    {slug === 'catering services' && (
                                    <div className="row mt-4">
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src={simg3} alt=""/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src={simg4} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                </div>
                                {slug === 'spices and ingredients' && (
                                    <div className="row mt-4">
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src={simg5} alt=""/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src={simg6} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                      {slug === 'household needs' && (
                                    <div className="row mt-4">
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src={simg7} alt=""/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src={simg8} alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                     
                                <div className="wpo-service-single-item list-widget">
                                    <div className="wpo-service-single-title">
                                        <h3>Our Capabilities</h3>
                                    </div>
                                    
                                    {/* Service-specific capabilities */}
                                    {slug === 'injera' && (
                                        <>
                                            <p>We provide freshly made injera with various options to meet your needs:</p>
                                            <ul>
                                                <li>100% teff flour injera (gluten-free)</li>
                                                <li>Mixed flour options available</li>
                                                <li>Bulk orders for events and restaurants</li>
                                                <li>Consistent quality and authentic taste</li>
                                                <li>Available by pre-order for freshness</li>
                                            </ul>
                                        </>
                                    )}
                                    {slug === 'spices and ingredients' && (
                                        <>
                                            <p>Our spice offerings include:</p>
                                            <ul>
                                                <li>Authentic berbere spice blend (mild and hot varieties)</li>
                                                <li>Mitmita (spicy seasoning powder)</li>
                                                <li>Korerima (Ethiopian cardamom)</li>
                                                <li>Shiro powder (seasoned chickpea flour)</li>
                                                <li>Specialty Ethiopian coffee beans</li>
                                            </ul>
                                        </>
                                    )}
                                    {slug === 'catering services' && (
                                        <>
                                            <p>Our catering services include:</p>
                                            <ul>
                                                <li>Full traditional coffee ceremony service</li>
                                                <li>Customizable menu options (meat, vegetarian, vegan)</li>
                                                <li>Complete setup with traditional serving items</li>
                                                <li>Staffing for professional service</li>
                                                <li>Flexible pricing for different group sizes</li>
                                            </ul>
                                        </>
                                    )}
                                    {slug === 'household needs' && (
                                        <>
                                            <p>We offer these household essentials:</p>
                                            <ul>
                                                <li>Traditional jebena (coffee pots) in various sizes</li>
                                                <li>Mesob (woven serving baskets)</li>
                                                <li>Injera-making supplies</li>
                                                <li>Cultural clothing and accessories</li>
                                                <li>Specialty cookware for Ethiopian cuisine</li>
                                            </ul>
                                        </>
                                    )}
                                </div>
                                <div className="wpo-service-single-item">
                                    <div className="wpo-service-single-title">
                                        <h3>Our approach</h3>
                                    </div>
                                    
                                    {/* Service-specific approaches */}
                                    {slug === 'injera' && (
                                        <p>We use traditional fermentation techniques passed down through generations. 
                                        Our process begins with high-quality teff flour and pure water, allowing natural 
                                        fermentation to develop the distinctive flavor. We maintain strict quality control 
                                        at every step to ensure authentic taste and texture in every batch.</p>
                                    )}
                                    {slug === 'spices and ingredients' && (
                                        <p>We work directly with Ethiopian farmers and suppliers to source the freshest, 
                                        highest quality spices. Our spices are carefully selected, cleaned, and packaged 
                                        to preserve their authentic flavors. We test every batch to ensure it meets our 
                                        standards for aroma, flavor, and quality.</p>
                                    )}
                                    {slug === 'catering services' && (
                                        <p>We approach each event as a unique opportunity to share Ethiopian culture. 
                                        Our chefs use traditional recipes and cooking methods, while our service staff 
                                        ensures an authentic dining experience. We work closely with clients to customize 
                                        menus and create memorable events that honor Ethiopian culinary traditions.</p>
                                    )}
                                    {slug === 'household needs' && (
                                        <p>We carefully select each household item for authenticity and quality. 
                                        Many products are handmade by Ethiopian artisans using traditional methods. 
                                        We aim to provide items that are both functional and meaningful, helping 
                                        customers maintain cultural connections through everyday objects.</p>
                                    )}
                                </div>
                            
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <ServiceSidebar/>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ServiceSinglePage;